import React, { useEffect } from "react";
import { Channel, ChannelProps, DefaultSuggestionListItem, MessageStatus, useChatContext, useMessageContext } from "stream-chat-react";
import CustomAttachment from "./CustomAttachment";
import CustomAttachmentSelector from "./CustomAttachmentSelector";
import { EmojiPicker } from "stream-chat-react/emojis";
import { useNavigate, useParams } from "react-router-dom";
import { ChatChannelType } from "../../../models/ChatChannel";
import { useAuth } from "../../../hooks/useAuth";
import mixpanel from "../../../utils/MixPanel";
import { AuthenticationStatusGetStream } from "../../../store/slices/authSlice";
import { User } from "stream-chat";
import { useStream } from "../../../hooks/useStream";

interface CustomChannelProps extends ChannelProps {
    children: React.ReactNode;
}

const customReactionOptions = [
    {
        type: "lmao",
        Component: () => <>🤣</>,
        name: "LMAO",
    },
    {
        type: "thumbsup",
        Component: () => <>👍</>,
        name: "Thumbs Up",
    },
    {
        type: "heart",
        Component: () => <>❤️</>,
        name: "Heart",
    },
    {
        type: "thumbsdown",
        Component: () => <>👎</>,
        name: "Thumbs Down",
    },
    {
        type: "fire",
        Component: () => <>🔥</>,
        name: "Fire",
    },
    {
        type: "rocket",
        Component: () => <>🚀</>,
        name: "Rocket",
    },
    /*{
        type: "sad",
        Component: () => <>😢</>,
        name: "Sad",
    },*/
    {
        type: "wow",
        Component: () => <>😮</>,
        name: "Wow",
    },
    {
        type: "pray",
        Component: () => <>🙏</>,
        name: "Pray",
    },
    {
        type: "cool",
        Component: () => <>🤙</>,
        name: "Cool",
    },
    {
        type: "100%",
        Component: () => <>💯</>,
        name: "100%",
    }
];

const CustomSuggestionItem = (props: any) => {
    if(props?.item?.description === 'Post a random gif to the channel') {
        props.item.description = 'Post a gif';
    }

    return <DefaultSuggestionListItem {...props} />
};

const MessageReadStatus = () => {
    const { readBy } = useMessageContext('MessageReadStatus');
    const {pleb} = useAuth();

    const readersWithoutOwnUser = readBy
        ? readBy.filter((item) => item.id !== pleb?.id)
        : [];

    const readByTxt = readersWithoutOwnUser.length > 1 ? `Read by ${readersWithoutOwnUser.length} people` : 'Read';

    return <div className="flex flex-row items-center cursor-default" title={readByTxt}>
        {readersWithoutOwnUser.length > 1 ? <span className="text-brand-orange">{readersWithoutOwnUser.length}&nbsp;</span> : null}
        <span className="material-symbols-outlined text-brand-orange text-[18px]">done_all</span>
    </div>
}

const CustomChannel = ({children}: CustomChannelProps) => {
    const { channel, client, setActiveChannel } = useChatContext();
    const { type, id } = useParams();
    const {statusGetStream} = useStream();
    const navigate = useNavigate();
    const {tab} = useParams();

    useEffect(() => {
        if(statusGetStream === AuthenticationStatusGetStream.LOGGED)
        {
            let channelType = '';

            switch (type) {
                case 'user':
                    channelType = ChatChannelType.Messaging;
                    break;
                case 'event':
                    channelType = ChatChannelType.Event;
                    break;
                case 'group':
                    channelType = ChatChannelType.Group;
                    break;
            }

            const channel = client.channel(channelType, id);
            setActiveChannel(channel);
        }
        else {
            setActiveChannel(undefined);
        }
    }, [id, type, client, setActiveChannel, statusGetStream]);

    useEffect(() => {
        mixpanel.track('WebApp - channel load', {
            channel: channel?.id
        });
    }, [channel]);

    const handleUserClick = (event: React.BaseSyntheticEvent, user?: User) => {
        if(user) {
            navigate(`/home/${tab}/user/${user.id}`);
        }
    }

    return <Channel 
        channel={channel}
        EmojiPicker={EmojiPicker}
        reactionOptions={customReactionOptions}
        MessageStatus={() => <MessageStatus 
            MessageReadStatus={() => <MessageReadStatus />}
            MessageDeliveredStatus={() => <span className="material-symbols-outlined cursor-default text-[18px]" title="Delivered">check</span>}
        />}
        Attachment={CustomAttachment}
        AttachmentSelector={CustomAttachmentSelector}
        AutocompleteSuggestionItem={CustomSuggestionItem}
        activeUnreadHandler={() => {
            // Dont do anything
        }}
        onMentionsClick={handleUserClick}
    >
        {children}
    </Channel>
}

export default CustomChannel;
